(function () {
  function sortHeaderWorkshopCards() {
    const utils = window.WorkshopDateUtils;
    if (!utils) return;

    const cards = Array.from(document.querySelectorAll('[data-header-workshop-card]'));
    if (!cards.length) return;
    const now = new Date();

    const listMap = new Map();
    cards.forEach((card) => {
      const slide = card.classList.contains('splide__slide')
        ? card
        : card.closest('.splide__slide');
      const list = card.closest('.splide__list') || card.parentElement;
      if (!slide || !list) return;
      if (!listMap.has(list)) listMap.set(list, []);
      listMap.get(list).push({ card, slide });
    });

    listMap.forEach((items, list) => {
      items.sort((a, b) => utils.compareWorkshopItems(a.card, b.card, 1, now));
      items.forEach((item) => list.appendChild(item.slide));
    });
  }

  function init() {
    sortHeaderWorkshopCards();
    setTimeout(sortHeaderWorkshopCards, 300);
    setTimeout(sortHeaderWorkshopCards, 1000);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  document.addEventListener('shopify:section:load', init);
})();
